import React, { useEffect, useState } from "react";
import "../css/header.css";
import DesktopMenuItem from "./DesktopMenuItem";

const BASE = "https://www.lva.virginia.gov";
const MENU_URL = `${BASE}/system/menu/main/linkset`;

const Header = () => {
  const [menuData, setMenuData] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Only show focus outlines when tabbing
  useEffect(() => {
    const handleFirstTab = (e) => {
      if (e.key === "Tab") {
        document.body.classList.add("user-is-tabbing");
        window.removeEventListener("keydown", handleFirstTab);
      }
    };
    window.addEventListener("keydown", handleFirstTab);
  }, []);

  // Fetch menu
  useEffect(() => {
    fetch(MENU_URL, { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((data) => {
        const items = data.linkset[0]?.item || [];
        const map = {};
        const roots = [];

        items.forEach((it) => {
          const lvl = it.hierarchy.map(Number);
          map[lvl.join("-")] = {
            title: it.title,
            href: it.href.match(/^https?:/) ? it.href : BASE + it.href,
            order: lvl.at(-1),
            children: [],
          };
        });

        items.forEach((it) => {
          const lvl = it.hierarchy.map(Number);
          const id = lvl.join("-");
          if (lvl.length === 1) roots.push(map[id]);
          else map[lvl.slice(0, -1).join("-")]?.children.push(map[id]);
        });

        const sortTree = (nodes) => {
          nodes.sort((a, b) => a.order - b.order);
          nodes.forEach((n) => n.children.length && sortTree(n.children));
        };
        sortTree(roots);
        setMenuData(roots);
      });
  }, []);

  const buildMobileMenu = (items) => (
    <ul id="mobile-menu-list">
      <li className="mobile-item mobile-search">
        <a href={`${BASE}/aggregated-search`}>
          <i className="fa fa-search" /> Search
        </a>
      </li>
      {items.map((item) => (
        <MobileMenuItem key={item.title} item={item} />
      ))}
    </ul>
  );

  return (
    <header id="main-header">
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <div id="top">
        <div id="logo">
          <a href={BASE}>
            <img
              src={`${BASE}/themes/custom/lva_2/images/logo_stack.svg`}
              alt="Library of Virginia Logo"
            />
          </a>
        </div>
        <button
          id="mobile-toggle"
          aria-label="Open menu"
          onClick={() => setMobileOpen(true)}
        >
          <i className="fa fa-bars" />
        </button>
        <nav className="desktop-nav" aria-label="Primary navigation">
          <ul role="menubar" id="desktop-menu">
            {menuData.map((item) => (
              <DesktopMenuItem key={item.title} item={item} />
            ))}
            <li className="search-link">
              <a href={`${BASE}/aggregated-search`} aria-label="Search">
                <i className="fa fa-search" />
              </a>
            </li>
          </ul>
        </nav>
      </div>

      {mobileOpen && (
        <div
          className="mobile-menu"
          id="mobile-menu"
          style={{ display: "block" }}                // ← override the default `display: none`
          role="dialog"
          aria-modal="true"
          aria-label="Mobile menu"
        >
          <header>
            <button
              id="mobile-close"
              aria-label="Close menu"
              onClick={() => setMobileOpen(false)}
            >
              <i className="fa fa-close" />
            </button>
          </header>
          {buildMobileMenu(menuData)}
        </div>
      )}
    </header>
  );
};

const MobileMenuItem = ({ item }) => {
  const [open, setOpen] = useState(false);

  return (
    <li>
      <div className="mobile-item">
        <a href={item.href}>{item.title}</a>
        {item.children.length > 0 && (
          <button
            className="sub-toggle"
            onClick={(e) => {
              e.preventDefault();
              setOpen(!open);
            }}
            aria-label="Toggle submenu"
          >
            <i className={`fa fa-caret-${open ? "up" : "down"}`} />
          </button>
        )}
      </div>
      {open && (
        <ul>
          {item.children.map((child) => (
            <MobileMenuItem key={child.title} item={child} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default Header;

